module.exports = __webpack_public_path__ + "img/paesaggio 3.e2f63cdc.jpeg";